export default __webpack_public_path__ + "static/media/sign-in-welcome-5.7a0bc8ce.jpg";